import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./GameResult.scss";
import AllDataClass from "pages/common/AllDataClass";
import { useTranslation } from "react-i18next";
import ViewPlan from "./ResultViewPlan";
import YoungSad from "../../images/young_sad.png";
import YoungHappy from "../../images/young_happy.png";
import OldSad from "../../images/old_sad.png";
import OldHappy from "../../images/old_happy.png";
import DistoryedTower from "../../images/tower_distroyed.gif";
import HalfDistoryTower from "../../images/tower_half_distroyed.gif";
import Tower from "../../images/tower.gif";

const GameResult = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);
  const [openViewPlan, setOpenViewPlan] = useState(false);
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [gameid, setUserID] = useState("");
  const [debtLevel, setDebtLevel] = useState(1);
  const [username, setUserName] = useState("");
  const [debt, setDebet] = useState([]);
  const [selectedPolicyLists, setSelectedPolicyLists] = useState([]);
  const [starScore, setStarScore] = useState([]);
  const [GoalMeet, setGoalMeet] = useState(false);
  const [PYI, setPYI] = useState(0.0);
  const [fullMeetCnt, setFullMeetCnt] = useState(0);
  const [partialMeetCnt, setpartialMeetCnt] = useState(0);
  const { state } = useLocation();

  useEffect(() => {
    setUserID(state.gameid);
    setUserName(state.username);
    setDebet([...state.debt]);
    setSelectedGoals([...state.selectedGoals]);
    setSelectedPolicyLists([...state.selectedPolicyLists]);
    setStarScore([...state.starScore]);
    setPYI(state.pyi);
  }, []);

  useEffect(() => {
    if (debt[debt?.length - 1]?.toFixed(1) > 180) {
      setDebtLevel(1);
    } else if (debt[debt?.length - 1]?.toFixed(1) > 150) {
      setDebtLevel(2);
    } else {
      setDebtLevel(3);
    }
  }, [debt]);

  useEffect(() => {
    setGoalMeet(getGoalScore());
    var fullmeet = 0;
    var partialmeet = 0;
    starScore.forEach((score) => {
      if (score >= 4) {
        fullmeet++;
        partialmeet++;
      } else if (score >= 3) {
        partialmeet++;
      }
    });
    setFullMeetCnt(fullmeet);
    setpartialMeetCnt(partialmeet);
  }, [starScore]);

  const getGoalScore = () => {
    var retVal = true;
    starScore.forEach((score) => {
      retVal = retVal && score >= 3;
    });
    return retVal;
  };

  const handleViwPlanClose = () => {
    setOpenViewPlan(false);
  };

  const GoalLists = () => {
    var goal_list = new Array();
    var points = starScore;
    // console.log(se)

    selectedGoals.map((selectedGoal: any, idx: number) => {
      var starPoint: any = points[idx];

      goal_list.push(
        <div className="gameresult-goal" key={idx}>
          <div className={`gameresult-goal-image ${selectedGoal.goalid}`}>
            <div
              className="goal-star2"
              style={{
                visibility: starPoint >= 3 ? "visible" : "hidden",
              }}
            />
            <div
              className="goal-star1"
              style={{
                visibility: starPoint >= 1 ? "visible" : "hidden",
              }}
            />
            <div
              className="goal-star3"
              style={{
                visibility: starPoint >= 4 ? "visible" : "hidden",
              }}
            />
          </div>
        </div>
      );
    });

    return goal_list;
  };

  const SaveGameIDandExit = async () => {
    try {
      await navigator.clipboard.writeText(gameid);
      alert(t("gameidcopied"));
    } catch (e) {
      alert("failed");
    } finally {
      navigate("/start");
    }
  };

  const compareCandidaterPlan = () => {
    navigate("/compare?cmpid=nutritious-indigo-sturgeon");
  };

  return (
    <div className="gameresult-root">
      <ViewPlan
        open={openViewPlan}
        handleClose={handleViwPlanClose}
        selectedGoals={selectedGoals}
        selectedPolicyLists={selectedPolicyLists}
        debt={debt}
        starScore={starScore}
        gameid={gameid}
        username={username}
        pyi={PYI}
        policyImpact={AllDataClass.getPolicyGovGoalImpactsForGoals(selectedPolicyLists)}
      />
      <div className="background-tower" />
      <div className="gameresult-title-wrap">
        {username === "이재명 후보님11" || username === "김문수 후보님11" ? (
          <>
            <div className="gameresult-title">
              {username === "이재명 후보님11" ? t("candidate1-res") : t("candidate2-res")}
            </div>
            <div className="gameresult-explain">{t("detail")}</div>
          </>
        ) : (
          <>
            <div className="gameresult-title">
              {username}
              {t("userplan")}
            </div>
            <div className="gameresult-explain">
              {t("result-explain")
                .split("\n")
                .map((item: any, idx: any) => (
                  <span key={idx}>
                    {item}
                    <br />
                  </span>
                ))}
            </div>
          </>
        )}
      </div>
      <div className="gameresult-goal-wrap">{GoalLists()}</div>
      <div className="gameresult-detail-wrap">
        <div className="gameresult-detail-othergoal" style={{ visibility: "hidden" }}>
          <div className="gameresult-detail-othergoal-text">
            {t("other-plan")
              .split("\n")
              .map((item: any, idx: any) => (
                <span key={idx}>
                  {item}
                  <br />
                </span>
              ))}
          </div>
          <button className="gameresult-detail-othergoal-button"></button>
        </div>
        <div className="gameresult-details">
          <div className="gameresult-details-wrap">
            <div className="galeresult-detail-title">
              <div className="galeresult-detail-title-icon"></div>
              <div className="galeresult-detail-title-text">{t("debtgoal-meet")}</div>
            </div>
            <div className="galeresult-detail-contens">
              <span>
                {t("debtgoal-text", {
                  debtratio: debt[debt?.length - 1]?.toFixed(1),
                  archive: debt[debt.length - 1] > 150 ? t("archive-fail") : t("archive-meet"),
                })}
              </span>
              <div className="pyi-result-wrap">
                <div className="pyi-result">
                  <img
                    className="pyi-result-img"
                    src={
                      debtLevel >= 3 ? Tower : debtLevel >= 2 ? HalfDistoryTower : DistoryedTower
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="gameresult-details-wrap">
            <div className="galeresult-detail-title">
              <div className="galeresult-detail-title-icon"></div>
              <div className="galeresult-detail-title-text">{t("PYI")}</div>
            </div>
            <div className="galeresult-detail-contens">
              <span>
                {t("PYI-text", {
                  pyi: PYI?.toFixed(1),
                  level:
                    PYI - 31.8 == 0
                      ? t("equal-pyi")
                      : PYI - 31.8 > 0
                        ? t("upper-pyi")
                        : t("lower-pyi"),
                  generation: PYI - 31.8 >= 0 ? t("future-gen") : t("current-gen"),
                })}
              </span>
              <div className="pyi-result-wrap">
                <div className="pyi-result young">
                  <img className="pyi-result-img" src={PYI - 31.8 < 0 ? YoungHappy : YoungSad} />
                </div>
                <div className="pyi-result old">
                  <img className="pyi-result-img" src={PYI - 31.8 >= 0 ? OldHappy : OldSad} />
                </div>
              </div>
            </div>
          </div>
          <div className="gameresult-details-wrap">
            <div className="galeresult-detail-title">
              <div className="galeresult-detail-title-icon"></div>
              <div className="galeresult-detail-title-text">{t("goal-meet")}</div>
            </div>
            <div className="galeresult-detail-contens">
              {fullMeetCnt == 3
                ? t("goal-full-meet-text")
                : partialMeetCnt == 3
                  ? t("goal-partial-meet-text")
                  : t("goal-fail-text")}
            </div>
          </div>
        </div>
        <div className="gameresult-bottoms">
          {username === "이재명 후보님11" || username === "김문수 후보님11" ? (
            <>
              <button className="gameresult-bottoms-button" onClick={() => setOpenViewPlan(true)}>
                {t("detail-res")}
              </button>
              <div className="gameresult-bottoms-myplan" onClick={() => compareCandidaterPlan()}>
                <div className="gameresult-bottoms-myplan-text">{t("CandidateComparison")}</div>
                <div className="gameresult-bottoms-myplan-button"></div>
              </div>
            </>
          ) : (
            <>
              <button className="gameresult-bottoms-button" onClick={() => SaveGameIDandExit()}>
                {t("play-agin")}
              </button>
              <div className="gameresult-bottoms-myplan" onClick={() => setOpenViewPlan(true)}>
                <div className="gameresult-bottoms-myplan-text">{t("view-myplan")}</div>
                <div className="gameresult-bottoms-myplan-button"></div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default GameResult;
